import { Grid } from "@material-ui/core";
import { get } from "lodash";
import * as React from "react";
import { useEffect, useState } from "react";
import { ErrorModal } from "../../../components/modals/error-modal";
import { LazyLoading } from "../../../controls/LazyLoading/LazyLoading";
import { TableProfiles } from "./components/ProfilesTable/TableProfiles";
import { useProfilesContext } from "./context/ProfileContext";
import { getProfiles } from "./repositories/ProfilesRepository";

type Props = {};

export const Profiles = (prop: Props) => {
	const { state, actions } = useProfilesContext();
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState("");

	const getProfilesFromAPI = async () => {
		setIsLoading(true);
		const resp = await getProfiles();
		if (resp.ok) {
			const profiles = get(resp, "data.tables[0].rows", []);
			actions.setProfiles(profiles);
			setIsLoading(false);
		} else {
			setError(resp.message);
		}
	};

	useEffect(() => {
		getProfilesFromAPI();
	}, []);

	if (state.profiles) {
		return (
			<>
				<Grid container justifyContent="center" alignItems="center">
					<Grid item md={12} xs={12} style={{ margin: 0 }}>
						<div style={{ width: "100%", padding: "10px 0 20px" }}>
							<TableProfiles
								isLoading={isLoading}
								getProfilesFromAPI={getProfilesFromAPI}
							/>
						</div>
					</Grid>
				</Grid>
				<ErrorModal error={error} onHide={() => setError("")} />
			</>
		);
	}
	return (
		<div
			style={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: "100vh",
			}}
		>
			<LazyLoading />
		</div>
	);
};
